import { Card, CardContent } from "@/components/ui/card";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { useEffect, useState } from "react";

function extractErrorFromHtml(html: string): string {
  const pMatch = html.match(/<p[^>]*>([^<]+)<\/p>/);
  if (pMatch) return pMatch[1].trim();
  return "Ocurrió un error al verificar tu email. Intenta de nuevo.";
}

export default function VerifyEmail() {
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) {
      setStatus("error");
      setErrorMsg("Token de verificación no válido o faltante.");
      return;
    }

    fetch(`/api/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(async (res) => {
        if (res.ok) {
          setStatus("success");
          setTimeout(() => {
            window.location.href = "/shop/login";
          }, 3000);
        } else {
          const html = await res.text();
          setStatus("error");
          setErrorMsg(extractErrorFromHtml(html));
        }
      })
      .catch(() => {
        setStatus("error");
        setErrorMsg("Error de conexión. Verifica tu conexión a internet e intenta de nuevo.");
      });
  }, []);

  return (
    <div className="min-h-screen bg-muted/30 flex items-center justify-center px-4">
      <Card className="w-full max-w-md shadow-xl border-primary/10 p-8">
        <CardContent className="text-center space-y-4">
          {status === "loading" && (
            <>
              <Loader2 className="h-12 w-12 mx-auto text-primary animate-spin" />
              <p className="text-lg font-medium">Verificando tu email...</p>
            </>
          )}

          {status === "success" && (
            <>
              <CheckCircle2 className="h-12 w-12 mx-auto text-green-500" />
              <h2 className="text-xl font-bold text-green-700">¡Email verificado!</h2>
              <p className="text-muted-foreground">
                Tu cuenta ha sido activada correctamente.
              </p>
              <p className="text-sm text-muted-foreground">
                Serás redirigido al inicio de sesión en 3 segundos...
              </p>
            </>
          )}

          {status === "error" && (
            <>
              <XCircle className="h-12 w-12 mx-auto text-red-500" />
              <h2 className="text-xl font-bold text-red-700">Error de verificación</h2>
              <p className="text-muted-foreground">{errorMsg}</p>
              <a
                href="/shop/login"
                className="inline-block mt-4 text-primary hover:underline font-medium"
              >
                Ir al inicio de sesión
              </a>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
